"use client";

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { useCallback } from "react";
import { useCurrentWorkspace } from "@/hooks/useCurrentWorkspace";
import type { WorkspacePermissionResourceKey } from "@/lib/constants/workspace-permission-resources";
import {
	type HasWorkspacePermissionOptions,
	hasWorkspacePermission,
	type WorkspacePermissionFlagsArg,
	type WorkspacePermissionInput,
} from "@/lib/utils/workspace-permissions";

/**
 * Permission checks for the **current workspace** from the session (object-shaped `workspace.permissions`).
 * For another member’s `WorkspacePermission[]`, call `hasWorkspacePermission` with that array directly.
 * Flat row objects without a `resource` field are not supported here.
 */
export function useWorkspacePermissionCheck() {
	const { workspace, workspaceId } = useCurrentWorkspace();
	const permissions: WorkspacePermissionInput = workspace?.permissions;

	const check = useCallback(
		(
			resourceKey: WorkspacePermissionResourceKey,
			flagOrFlags: WorkspacePermissionFlagsArg,
			options?: HasWorkspacePermissionOptions,
		) => hasWorkspacePermission(permissions, resourceKey, flagOrFlags, options),
		[permissions],
	);

	return { check, permissions, workspace, workspaceId };
}
